/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Title {
    MR = 'Mr',
    MISS = 'Miss',
    MRS = 'Mrs',
    PROF = 'Prof',
    DR = 'Dr',
    MS = 'Ms',
    LADY = 'Lady',
    LORD = 'Lord',
    MASTER = 'Master',
    SIR = 'Sir',
    DAME = 'Dame',
    SHEIKH = 'Sheikh',
    SHEIKHA = 'Sheikha',
    HRH = 'HRH',
    MX = 'MX',
    OTHER = 'Other',
}
